import { useEffect, useState } from "react";

function useDelayedShow() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return show;
}

export default function Spinner() {
  const show = useDelayedShow();

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-40 flex max-h-screen max-w-screen items-center justify-center bg-white/20">
      <div className="border-t-brand-primary border-dark-600 z-50 h-12 w-12 animate-spin rounded-full border-[3px] duration-500"></div>
    </div>
  );
}

export function MiniSpinner() {
  // Like spinner, but centered in the closest "position: relative" parent
  const show = useDelayedShow();

  if (!show) return null;

  return (
    <div className="absolute inset-0 z-40 flex h-full w-full items-center justify-center bg-white/20">
      <div className="border-t-brand-primary border-dark-600 z-50 h-12 w-12 animate-spin rounded-full border-[3px] duration-500"></div>
    </div>
  );
}
